import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import React from 'react';
import {i18n2} from '../../i18n/i18n';
import {profGralSpacSchema} from '../model/ProfGralSpac';
import useLoadProfGralSpac from '../hooks/useLoadProfGralSpac';
import IntegrityProfGralSpac from './IntegrityProfGralSpac';

const ProfGralSpacGrid = () => {
  const loadProfGralSpac = useLoadProfGralSpac();
  return (
    <IntegrityRoleGrid
      schema={profGralSpacSchema()}
      dataSource={loadProfGralSpac}
      id={['iD_ProfileSpac', 'iD_ProfGral']}
      allowExport={true}
      integrityGrid={IntegrityProfGralSpac}
      integrityId={['ID_ProfileSpac', 'ID_ProfGral']}
      integrityName={'ProfGralSpac'}
      exportName="ProfSpac-export"
    >
      <Column
        caption={`#${i18n2._('Profile-General')}`}
        defaultSortOrder={'asc'}
        dataField="iD_ProfGral"
      />
      <Column caption={i18n2._('#Perfil Spac')} dataField="iD_ProfileSpac" />
      <Column
        caption={`#${i18n2._('Perfil Spac')} ${i18n2._('Nombre')}`}
        dataField="profileSpac_Name"
      />
      <Column
        caption={`#${i18n2._('Profile-General')} ${i18n2._('Nombre')}`}
        dataField="profileGral_Name"
        defaultSortOrder={'asc'}
      />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.updateDate)}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default ProfGralSpacGrid;
